<h4>Add Recommendation</h4>
<p class="form-field-margin">
  <mat-form-field>
    <mat-select  required id="recommendation" [(ngModel)]="recommendation">
      <mat-option [value]="r.Id" *ngFor="let r of possibleRecommendations">{{r.Description}}</mat-option>
    </mat-select>
    <mat-label>{{'Select Recommended Action' | translate | async}}</mat-label>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'Action Date' | translate | async}}</mat-label>
    <input class="input-travel" matInput (click)="picker.open()" readonly [matDatepicker]="picker" placeholder="Choose a date" [(ngModel)]="actionDate" required />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-spinner diameter="24" *ngIf="loadingPossibleRecommendations"></mat-spinner>

  <mat-form-field>
    <mat-select required id="recommendation" [(ngModel)]="severityId">
      <mat-option [value]="r.Id" *ngFor="let r of SeverityDropDownList">{{r.Severitycategory}}</mat-option>
    </mat-select>
    <mat-label>{{'Severity' | translate | async}}</mat-label>
  </mat-form-field>
</p>
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'SMU/Hourmeter to Take Action' | translate | async}}</mat-label>
      <input id="smuToTakeAction" pattern="[0-9]*" [(ngModel)]="smuToTakeAction"  value="0" matInput placeholder="0" type="number" class="right-align"  />
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Hours Gained' | translate | async}}</mat-label>
      <input id="smuToCompleteAction" pattern="[0-9]*" [(ngModel)]="smuToCompleteActionBy"  value="0" matInput placeholder="0" type="number" class="right-align"  />
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
  </p>
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'Labour Cost' | translate | async}}</mat-label>
      <input id="labourCost" pattern="[0-9]*"  [(ngModel)]="labourCost"  value="0" matInput placeholder="0" type="number" class="right-align"  />
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Parts Cost' | translate | async}}</mat-label>
      <input id="partsCost" pattern="[0-9]*" [(ngModel)]="partsCost"  value="0" matInput placeholder="0" type="number" class="right-align"  />
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Misc. Cost' | translate | async}}</mat-label>
      <input id="miscCost" pattern="[0-9]*" [(ngModel)]="miscCost"  value="0" matInput placeholder="0" type="number" class="right-align"  />
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
  </p>
  <p class="full-width">
    <mat-form-field appearance="standard">
      <mat-label>{{'Comment' | translate | async}}</mat-label>
      <textarea id="comment" [(ngModel)]="comment"  matInput placeholder="{{'Enter any comments about why you recommend this. ' | translate | async}}"></textarea>
    </mat-form-field>
  </p>
  <div>
    <button mat-raised-button type="button" (click)="closeModal()">{{'Cancel' | translate | async}}</button>
    <button mat-raised-button color="warn" type="submit" [disabled]="savingForm" [class.loading]="savingForm" (click)="submit()">{{'Add Recommendation' | translate | async}}</button>
    <button mat-raised-button color="warn" (click)="submitForBothSides()" [disabled]=" savingForm" [class.loading]="savingForm">{{'Add For Both Sides' | translate | async}}</button>
  </div>


<!-- <h4>Add Recommendation</h4>
<form (ngSubmit)="onSubmit(form.value)" [formGroup]="form">
  <p class="select-recommendation">
    <mat-form-field>
      <mat-select required id="recommendation" [formControl]="form.controls['recommendation']">
        <mat-option [value]="r.Id" *ngFor="let r of possibleRecommendations">{{r.Description}}</mat-option>
      </mat-select>
      <mat-label>{{'Select Recommended Action' | translate | async}}</mat-label>
    </mat-form-field>
    <mat-spinner diameter="24" *ngIf="loadingPossibleRecommendations"></mat-spinner>
  </p>
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'SMU/Hourmeter to Take Action' | translate | async}}</mat-label>
      <input id="smuToTakeAction" pattern="[0-9]*" [formControl]="form.controls['smuToTakeAction']" value="0" matInput placeholder="0" type="number" class="right-align" required>
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Hours Gained' | translate | async}}</mat-label>
      <input id="smuToCompleteAction" pattern="[0-9]*" [formControl]="form.controls['smuToCompleteActionBy']" value="0" matInput placeholder="0" type="number" class="right-align" required>
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
  </p>
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'Labour Cost' | translate | async}}</mat-label>
      <input id="labourCost" pattern="[0-9]*" [formControl]="form.controls['labourCost']" value="0" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Parts Cost' | translate | async}}</mat-label>
      <input id="partsCost" pattern="[0-9]*" [formControl]="form.controls['partsCost']" value="0" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Misc. Cost' | translate | async}}</mat-label>
      <input id="miscCost" pattern="[0-9]*" [formControl]="form.controls['miscCost']" value="0" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
  </p>
  <p class="full-width">
    <mat-form-field appearance="standard">
      <mat-label>{{'Comment' | translate | async}}</mat-label>
      <textarea id="comment" [formControl]="form.controls['comment']" matInput placeholder="{{'Enter any comments about why you recommend this. ' | translate | async}}"></textarea>
    </mat-form-field>
  </p>
  <div>
    <button mat-raised-button type="button" (click)="closeModal()">{{'Cancel' | translate | async}}</button>
    <button mat-raised-button color="warn" type="submit" [disabled]="!form.valid || savingForm" [class.loading]="savingForm">{{'Add Recommendation' | translate | async}}</button>
    <button mat-raised-button color="warn" (click)="submitForBothSides(form)" [disabled]="!form.valid || savingForm" [class.loading]="savingForm">{{'Add For Both Sides' | translate | async}}</button>
  </div>
</form> -->
